module.exports = __webpack_public_path__ + "static/media/facebook.910fa8bf.svg";